import React, { useRef } from "react";
const LoanProduct = ({
  icon = "",
  thumbnail = "",
  title = "",
  list = [],
  color = {},
  containerStyle = {},
}) => {
  const { iconBg, contentBg = "", borderColor } = color;
  return (
    <div className={`flex ${containerStyle}`}>
      <div
        className={`inline-block overflow-hidden border-[0.5px] rounded-[16px]`}
        style={{ borderColor: "#42495259", backgroundColor: contentBg }}
      >
        <img
          src={thumbnail}
          alt={title}
          className="object-contain"
          draggable="false"
        />
        <div
          className={`content-section px-[20px] md:px-[33px] py-[12px] md:py-[30px] bg-opacity-[22%] relative`}
        >
          <div
            className={`w-[30px] md:w-[66px] aspect-square justify-center flex rounded-[60px] border-white border-[3px] absolute top-[-14px] md:top-[-33px] `}
            style={{ backgroundColor: iconBg }}
          >
            {icon && <img src={icon}
              alt="Contact Icon"
              className="w-[30px]"
              draggable="false"
            />}
          </div>
          <p className=" mt-[12px] md:mt-[33px] font-filson-soft font-[700] md:font-[500]  text-[14px] md:text-[24px] lg:text-[30px] md:leading-[24px]
          leading-[28px] text-[#0F1922] 
          ">{title}</p>
          <ul
            className={`font-Apparat  mt-[6px] md:mt-[13px] text-[${borderColor}] font-[600] text-[12px] md:text-[18px] leading-[16px] md:leading-[28px]`}
          >
            {list?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default LoanProduct
